module.exports = __webpack_public_path__ + "media/images/no_image-1027f7d9a5eff61c743059888cdcad71.jpg";